import { render, staticRenderFns } from "./ncsItem.vue?vue&type=template&id=0c72ecf4&"
import script from "./ncsItem.vue?vue&type=script&lang=js&"
export * from "./ncsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports